import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import DEFAULT_CONTENT from '../content/PAGE_CONTENT.json';
import '../styles/tokens.css';
import LegalFooter from '../components/LegalFooter';

/**
 * LegalPage — renders a static legal document (public/legal/{slug}.html)
 * inside the site chrome. Used for /privacy and /terms.
 */
export default function LegalPage({ slug, title }) {
  const [html, setHtml] = useState(null);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    let cancelled = false;
    window.scrollTo(0, 0);
    fetch(`/legal/${slug}.html`)
      .then((r) => (r.ok && r.headers.get('content-type')?.includes('text/html') ? r.text() : Promise.reject()))
      .then((t) => { if (!cancelled && !t.includes('<div id="root">')) setHtml(t); else if (!cancelled) setMissing(true); })
      .catch(() => { if (!cancelled) setMissing(true); });
    return () => { cancelled = true; };
  }, [slug]);

  return (
    <div style={{ background: 'var(--bg)', color: 'var(--cream)', minHeight: '100vh' }} data-testid={`legal-page-${slug}`}>
      <header className="legal-head">
        <Link to="/" data-testid="legal-home-link">
          <img className="logo" src={DEFAULT_CONTENT.meta.logo} alt={DEFAULT_CONTENT.meta.product_name} />
        </Link>
      </header>
      <section className="band">
        <div className="wrap narrow legal">
          {html && <div data-testid="legal-content" dangerouslySetInnerHTML={{ __html: html }} />}
          {missing && (
            <>
              <h1>{title}</h1>
              <p data-testid="legal-missing">This document will be published shortly. Questions: <a href={`mailto:${DEFAULT_CONTENT.footer.support_email}`}>{DEFAULT_CONTENT.footer.support_email}</a></p>
            </>
          )}
        </div>
      </section>
      <LegalFooter footer={DEFAULT_CONTENT.footer} />
    </div>
  );
}
